import React, {
   useState,
   useEffect,
} from 'react';
import PropTypes from 'prop-types';

import IconSvgConvert from './icon-convert';
import LogoSvgConvert from './logo-convert';
import CreateEditModal from 'common/components/modules/modal-wrapper';

import Loader from 'common/components/elements/loader/circle';
import './style.scss'

const CustomizeLogoModal = ({
   onClose,
   loading,
   type = 'favicon',
   saveCustomImg,
   data,
   siteName,
   colors,
   isMobile,
   fontList,
   loadingFont,
   isDemoMode,
}) => {
   let timeout = null
   const modalData = {
      favicon: {
         title: 'Customize your app icon',
         defaultSettings: data || {},
         id: 'app-icon-and-favicon',
      },
      main: {
         title: 'Customize your logo',
         defaultSettings: data || {},
         id: 'site-main-logo',
      },
   }
   const [settings, setSettings] = useState(modalData[type] && modalData[type].defaultSettings)

   useEffect(() => {
      return () => {
         clearTimeout(timeout)
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   function onSetLogoFont(font, text) {
      let updateData = {
         ...font,
         font_family: font.font,
         font_name: font.name,
         font_url: font.url,
      };
      if(text && settings.text !== text) {
         updateData = {
            ...updateData,
            text,
         }
      }
      setSettings({
         ...settings,
         ...updateData,
      })
   }

   function saveCustomLogo(){

      let width = 1024
      let height = 1024
      const svg = document.querySelector(`#${ modalData[type].id }`);
      if('main' === type) {
         const text = svg.querySelectorAll('text')[0].getBoundingClientRect();
         height = 56;
         width = text.width;
      }
      saveCustomImg(svg, type, settings, width, height)
   }
   function onChangeText(name, value) {
      if(value.length > 5){
         return
      }
      setSettings({
         ...settings,
         text: value,
      })
   }

   const buttonH = 36
   const modalH = 82
   return (
      <CreateEditModal
         type='action'
         icon='customize'
         title={ modalData[type].title }
         iconColor='action'
         buttonText='Done'
         action={ saveCustomLogo }
         onCloseModal={ onClose }
         contentWidth='600px'
         headerClass=''
         // textColor='[#FF3636]'
         isMobile={ isMobile }
         disabled={ loadingFont }
         loading={ loading }
         buttonClassName='mt-0 text-[#FF3636]'
         otherClassName='customize-logo-modal flex flex-col'
      >
         <div
            style={ { height: `calc(100% - ${ buttonH + modalH }px)` } }
            className='flex flex-col flex-1 py-4'
         >
            {
               loadingFont && (
                  <div className='flex flex-1 items-center justify-center'>
                     <Loader  />
                  </div>
               )
            }
            {
               !loadingFont && (
                  <>
                     {
                        'favicon' === type && (
                           <IconSvgConvert
                              settings={ settings }
                              colors={ colors }
                              fontList={ fontList }
                              setSettings={ (...arg) => setSettings(...arg) }
                              onSelectFont={ (font) => onSetLogoFont(font) }
                              onChangeText={ onChangeText }
                              isMobile={ isMobile }
                              defaultSettings={ data }
                           />
                        )
                     }
                     {
                        'main' === type && (
                           <LogoSvgConvert
                              settings={ settings }
                              colors={ colors }
                              fontList={ fontList }
                              setSettings={ (...arg) => setSettings(...arg) }
                              onSelectFont={ (font, text) => onSetLogoFont(font, text) }
                              text={ siteName.charAt(0).toUpperCase() + siteName.slice(1) }
                              isMobile={ isMobile }
                              saveCustomColor={ () => {} }
                              fontIsLoad={ loadingFont }

                           />
                        )
                     }
                  </>
               )
            }
         </div>
      </CreateEditModal>
   )

}

CustomizeLogoModal.propTypes = {
   onClose: PropTypes.func,
   saveCustomImg: PropTypes.any,
   loading: PropTypes.bool,
   type: PropTypes.string,
   data: PropTypes.object,
   siteName: PropTypes.string,
   colors: PropTypes.array,
   isMobile: PropTypes.bool,
   fontList: PropTypes.array,
   loadingFont: PropTypes.bool,
   isDemoMode: PropTypes.bool,
}
export default CustomizeLogoModal
